import { useQuery } from "@tanstack/react-query";
import useWidgetStore from "../../store/useWidgetStore";
import ConfigHolder from "../../config/ConfigHolder";
import { apiSign } from "../../context/WidgetContext";
import { useSettings } from "../../context/SettingsContext";
export const useSetConsumer = (options) => {
    const { api_key, widget_id, contracts } = useSettings();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    const { language, consumer, booking } = useWidgetStore();
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-setCustomer'], queryFn: async ({ signal }) => {
            var _a, _b, _c, _d;
            let url = new URL(`/consumer/booking/api/method/setCustomer`, ConfigHolder.apiBaseUrl);
            const data = Object.assign(Object.assign({}, consumer), { consumerType: "consumer", acceptTerms: 0, acceptPrivacy: 0, mailingLists: 0 });
            if (consumer.contracts) {
                if (consumer.contracts.includes('acceptTerms')) {
                    let _contract = contracts.find((_contract) => {
                        return 'acceptTerms' === _contract.name;
                    });
                    if (_contract)
                        data['acceptTerms'] = _contract === null || _contract === void 0 ? void 0 : _contract.value;
                }
                if (consumer.contracts.includes('acceptPrivacy')) {
                    let _contract = contracts.find((_contract) => {
                        return 'acceptPrivacy' === _contract.name;
                    });
                    if (_contract)
                        data['acceptPrivacy'] = _contract === null || _contract === void 0 ? void 0 : _contract.value;
                }
                if (consumer.contracts.includes('mailingLists')) {
                    let _contract = contracts.find((_contract) => {
                        return 'mailingLists' === _contract.name;
                    });
                    if (_contract)
                        data['mailingLists'] = _contract === null || _contract === void 0 ? void 0 : _contract.value;
                }
            }
            if (consumer.business && data['type'] === 'business') {
                for (const [business_key, business_value] of Object.entries(consumer.business)) {
                    // of course there is an exception, on consumer it's zipcode, on business it's zipCode
                    if (business_key === 'id')
                        continue;
                    //@ts-ignore
                    data[business_key === 'zipCode' ? 'zipcode' : business_key] = business_value;
                }
                // and another exception, some requests use type, others consumerType, on the same object
                // type is the one that is set using the radiobuttons and represents the actual form state
                // i.e., consumerType could be set via login
                data['consumerType'] = data['type'];
            }
            // here we merge the custom fields into the overal fields
            let filtered = Object.assign(Object.assign({}, data), consumer.fields);
            // then we remove the fields array
            delete filtered.fields;
            delete filtered.contracts;
            for (const [key, value] of Object.entries(filtered)) {
                if (typeof value === 'object') {
                    // @ts-ignore
                    filtered[key] = JSON.stringify(value);
                }
                // else if (value === null) {
                //     // how do we delete filtered.key, where key is a variable
                // }
                else if (['zipcode', 'houseNumber'].includes(key)) {
                    if (value === undefined) {
                        // @ts-ignore
                        filtered[key] = '';
                    }
                }
                else if (['username', 'password'].includes(key)) {
                    if (consumer.hasUserAccount) {
                        delete filtered.username;
                        delete filtered.password;
                    }
                }
            }
            if (consumer.houseNumber) {
                filtered.houseNr = consumer.houseNumber;
            }
            if (consumer.street) {
                filtered.address = consumer.street;
            }
            if (!consumer.mandate) {
                delete filtered.mandate;
            }
            let appTypes = [];
            if (booking.appointments) {
                booking.appointments.forEach((appointment) => {
                    appointment.components.forEach((component) => {
                        if (component.appointmentTypes) {
                            // appTypeId is a bit of an misnomer as its always an array
                            appTypes = appTypes.concat(component.appointmentTypes);
                        }
                    });
                });
                let unique = [...new Set(appTypes)];
                filtered.appointmentType = unique.join(',');
            }
            let api_salt = Date.now(), body = new URLSearchParams(filtered);
            // body: string = JSON.stringify(filtered) // use this to post JSON
            let _params = Object.assign(Object.assign({}, filtered), { applicationId: (_b = (_a = process.env) === null || _a === void 0 ? void 0 : _a.YII_API_APPLICATION_ID) !== null && _b !== void 0 ? _b : 'widget-booking', method: 'setCustomer', widget_id: widget_id });
            url.searchParams.set('api_signature', apiSign(_params, api_key, api_salt));
            url.searchParams.set('api_format', 'json');
            url.searchParams.set('api_lang', language);
            url.searchParams.set('api_salt', api_salt.toString());
            url.searchParams.set('applicationId', (_d = (_c = process.env) === null || _c === void 0 ? void 0 : _c.YII_API_APPLICATION_ID) !== null && _d !== void 0 ? _d : 'widget-booking');
            url.searchParams.set('api_key', api_key);
            url.searchParams.set('widget_id', widget_id);
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST",
                headers: {
                    // 'Content-Type': 'application/json', // use this to post JSON
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/ld+json',
                },
                body: body
            });
            return response.json();
        } }));
};
